import { s } from '@/theme/tokens';
import { Box, Surface } from '@/ui/primitives';
import { buildChartPanelSurfaceSx } from './chartPanelSurfaceSx';
import type { SxProps, Theme } from '@/ui/primitives';
import type { ReactElement, ReactNode } from 'react';

type MetricsChartPanelFrameSx = Exclude<
  Extract<SxProps<Theme>, readonly unknown[]>[number],
  boolean
>;

type MetricsChartPanelFrameProps = {
  height: number;
  header: ReactNode;
  children: ReactNode;
  headerPaddingX?: string;
  headerPaddingTop?: string;
  headerPaddingBottom?: string;
  contentPaddingX?: string;
  contentPaddingTop?: string;
  contentPaddingBottom?: string;
  headerSx?: MetricsChartPanelFrameSx;
  contentSx?: MetricsChartPanelFrameSx;
};

export const MetricsChartPanelFrame = ({
  height,
  header,
  children,
  headerPaddingX = s('lg'),
  headerPaddingTop = s('lg'),
  headerPaddingBottom = s('xs'),
  contentPaddingX = s('none'),
  contentPaddingTop = s('none'),
  contentPaddingBottom = s('none'),
  headerSx,
  contentSx,
}: MetricsChartPanelFrameProps): ReactElement => (
  <Surface
    padding="none"
    radius="card"
    sx={[
      ...buildChartPanelSurfaceSx({ height }),
      {
        display: 'flex',
        flexDirection: 'column',
      },
    ]}
  >
    <Box
      sx={[
        {
          minWidth: 0,
          px: headerPaddingX,
          pt: headerPaddingTop,
          pb: headerPaddingBottom,
          boxSizing: 'border-box',
        },
        ...(headerSx ? [headerSx] : []),
      ]}
    >
      {header}
    </Box>
    <Box
      sx={[
        {
          flex: '1 1 auto',
          minHeight: 0,
          px: contentPaddingX,
          pt: contentPaddingTop,
          pb: contentPaddingBottom,
          boxSizing: 'border-box',
        },
        ...(contentSx ? [contentSx] : []),
      ]}
    >
      {children}
    </Box>
  </Surface>
);
